module.exports = __webpack_public_path__ + "static/img/FR.91e57fbb.svg";